// Components
import { Link } from '@tracklib/kit'
import Signup from 'components/nologin/signup'
import Card from 'components/subscribe/card'

import styles from './signup.css'

type SignupWrapperProps = {
  refcode?: string
  refcodevalid?: boolean
  showSignupCode?: boolean
}

const SignupWrapper = ({ refcode, refcodevalid, showSignupCode }: SignupWrapperProps): JSX.Element => {
  return (
    <Card>
      <Signup refcode={refcode} refcodeValid={refcodevalid} showSignupCode={showSignupCode} />
      <div className={styles.noAccountText}>
        <p>
          Already a member?{' '}
          <Link to="login" datatesting="signup-login-button" modal className="signupButton">
            Login
          </Link>
        </p>
      </div>
    </Card>
  )
}

export default SignupWrapper
